module.exports = __webpack_public_path__ + "img/16l006-02.ad672ddb.jpg";